import { ReactComponent as CheckBoxOutlined } from "assets/icons/check-box-outlined.svg";
import { ReactComponent as CheckBoxOutlinedBlank } from "assets/icons/check-box-outlined-blank.svg";
import * as React from 'react';
import { ReactNode } from "react";

interface ICheckboxProps {
    checkedValue: true | false | 'partial',
    toggle?: () => void,
}

export const Checkbox = (props: ICheckboxProps) => {
    const onClick = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        if (props.toggle) {
            e.stopPropagation();
            props.toggle();
        }
    };

    return (
        <div className={"check-box" + (props.checkedValue === 'partial' ? " partial" : "")}>
            {
                props.checkedValue !== false
                    ? <CheckBoxOutlined onClick={onClick} />
                    : <CheckBoxOutlinedBlank onClick={onClick} />
            }
        </div>
    );
};

interface ILablledCheckboxProps extends ICheckboxProps {
    children: ReactNode
}

export const LabelledCheckbox = (props: ILablledCheckboxProps) => {
    const onClick = (e: React.MouseEvent<HTMLSpanElement>) => {
        if (props.toggle) {
            e.stopPropagation();
            props.toggle();
        }
    };

    return (
        <span className="labelled-checkbox" onClick={onClick}>
            <Checkbox checkedValue={props.checkedValue} />
            <span className="checkbox-label">{props.children}</span>
        </span>
    );
};